@if (product) {
  <div class="product-wrapper fx-layout-column fx-align--space-between-x" [ngClass]="{inactive: !product.active}">
    <div class="inactive-message">
      Temporarily<br />Out of Stock
    </div>
    <div>
      <div [ngClass]="{'landscape': thumbOrientation === 'landscape'}" class="square-container"
        [ngStyle]="{'background-image': product.thumbPreviewBackground ? 'url(' + product.thumbPreviewBackground + ')' : null}">
        <div class="image-wrapper" [ngClass]="{'show-kit': product.project?.primaryProduct === 'SHOW-KIT' && product.thumbPreviewStyle == 'GENERATED'}">
          <img loading="lazy"
            [src]="product.image?.src"
            (click)="showThumbOrRedirect(product.image?.largeImageSrc)"
            [matTooltip]="toolTip(product.image?.src)"
            [ngClass]="{shadow: product.image?.shadow}"
            [alt]="product.name"
            />
          </div>
          <div class="selections-wrapper">
            @if (product.project && !product.fixedProject && !projectIsPreview) {
              <table>
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ product.project.size }}</strong>
                      @if (product.project.numOpenings == 1) {
                        /w <strong>{{ product.project.opening.size }}</strong> Opening
                      }
                      <button mat-mini-fab color="secondary" (click)="chooseSize()">
                        <mat-icon svgIcon="pencil" class="sm"></mat-icon>
                      </button>
                    </td>
                  </tr>
                  <!--
                  <tr *ngIf="product.project.backingBoard && product.project.backingBoard.description">
                    <th>Backing:</th>
                    <td>{{ product.project.backingBoard.description }}</td>
                  </tr>
                  <tr *ngIf="product.project.bag">
                    <th>Clear Bag:</th>
                    <td>Yes</td>
                  </tr>
                  -->
                </tbody>
              </table>
            }
            @for (prop of ['moulding','topMat','bottomMat','backingBoard','glazing']; track prop) {
              @if (product.project && !projectIsPreview && product.project[productCategories[prop].projectProperty] && multiOption(product.projectData[productCategories[prop].projectDataProperty])) {
                <table>
                  <tbody>
                    <tr>
                      <th>{{ productCategories[prop].titleAfterChosen ? productCategories[prop].titleAfterChosen : productCategories[prop].title }}:</th>
                      <td>
                        {{ partDisplay.description(product.project[productCategories[prop].projectProperty]) }}
                        @if (!product.fixedProject) {
                          <button mat-mini-fab color="secondary" (click)="openSelectorDialog(productCategories[prop])">
                            <mat-icon svgIcon="pencil" class="sm"></mat-icon>
                          </button>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            }
          </div>
        </div>
        <h3>
          @if (product.packSize > 1) {
            ({{product.packSize}})
          }
          <span [innerHtml]="product.name"></span>
        </h3>
        @if (product.description) {
          <span [innerHtml]="product.description"></span>
        }
      </div>
      <div class="bottom-section xfx-layout-column xfx-align--end-x xfx-align--x-center">
        @if (product.project && !projectIsPreview) {
          <mbnm-shop-detail-buy-section
            [product]="product">
          </mbnm-shop-detail-buy-section>
        }

        @if (projectIsPreview && product.project) {
          <span class="price">
            @if (product.project.qty === 1 && product.project.price !== product.project.maxPrice) {
              <s>{{ product.project.maxPrice | currency }}</s>
            }
            @if (product.project.price === product.project.minPrice === product.project.maxPrice) {
              <b>{{ product.project.price | currency }}</b>
            } @else {
              <b>*{{ product.project.minPrice | currency }}</b> - <b>{{ product.project.maxPrice | currency }}</b>
              <div>* with volume discounts</div>
            }
          </span>
        }

        <!-- primary action button -->
        @if (product.builderButton.link !== 'NONE') {
          <button mat-flat-button color="primary" (click)="primaryButtonClicked($event)">
            @if (product.sizeSelector !== 'NONE' && projectIsPreview) {
              {{ product.builderButton.chooseOptionsText}}
            }
            @if (product.sizeSelector == 'NONE' || (product.project && !projectIsPreview)) {
              {{ product.builderButton.text }}
            }
          </button>
        }
      </div>
    </div>
  }
